/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS)Side Nav Maintenance Icon component.
 */
export const SideNavMaintenanceIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SideNavMaintenanceIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M14.914 12.475l2.54 2.54a.44.44 0 00.411.111c1.277-.293 2.686.08 3.596 1.098.83.928 1.04 2.125.668 3.182-.092.26-.42.304-.612.107l-.002-.003c-.028-.028-.493-.5-1.03-1.053a.501.501 0 00-.713-.006l-1.29 1.29a.5.5 0 000 .707l1.055 1.056c.193.193.148.518-.11.61-1.06.377-2.26.168-3.192-.665-1.016-.91-1.39-2.32-1.097-3.595a.44.44 0 00-.111-.412l-2.54-2.54M8.504 10.943l-2.54-2.54a.44.44 0 00-.412-.111c-1.276.293-2.685-.081-3.595-1.098-.83-.928-1.04-2.125-.668-3.182.091-.26.42-.304.611-.107l.003.003c.028.028.493.5 1.03 1.053.194.2.515.204.713.006l1.29-1.29a.5.5 0 000-.707L3.88 1.914c-.193-.193-.147-.518.11-.61 1.06-.377 2.261-.168 3.192.665 1.017.91 1.39 2.319 1.098 3.595a.44.44 0 00.11.412l2.54 2.54'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round' />
        <path clipRule='evenodd'
          d='M16.817 4.806l3.348-2.412 1.46 1.41-2.399 3.327-2.409-2.325z'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
        <path d='M6.997 14.233a.452.452 0 01.638 0l1.993 1.993a.452.452 0 010 .639l-4.72 4.72a1.807 1.807 0 01-2.554 0l-.077-.078a1.806 1.806 0 010-2.555l4.72-4.719zM8.741 15.151l9.017-9.048'
          stroke={iconColor}
          strokeWidth={1.5} />
      </svg>
    )} />
  );
};
